import { gql } from '@apollo/client';

// Bank transactions list query
export const GET_BANK_TRANSACTIONS_QUERY = gql`
  query GetBankTransactions($bankAccountId: UUID, $organizationId: UUID, $studyId: UUID, $limit: Int = 100, $offset: Int = 0) {
    bankTransactions(bankAccountId: $bankAccountId, organizationId: $organizationId, studyId: $studyId, limit: $limit, offset: $offset) {
      edges {
        id
        transactionDate
        postedDate
        amountMicros
        transactionType
        status
        referenceNumber
        description
        createdAt
        reconStatus
        isCoMingled
        studyCount
        studyAmountMicros
        remittanceCount
        documents {
          id
          originalFilename
          documentType
        }
      }
      totalCount
    }
  }
`;

// Bank transaction detail query (with documents)
export const GET_BANK_TRANSACTION_QUERY = gql`
  query GetBankTransaction($id: UUID!) {
    bankTransaction(id: $id) {
      id
      bankAccountId
      transactionDate
      postedDate
      amountMicros
      currencyCode
      transactionType
      source
      status
      reconStatus
      externalTransactionId
      referenceNumber
      description
      createdAt
      documents {
        id
        originalFilename
        documentType
        mimeType
        createdAt
      }
      isCoMingled
      studyCount
      remittanceCount
      linkedStudies {
        studyId
        studyName
        protocolId
        primaryAlias
        amountMicros
      }
    }
  }
`;

// User bank accounts query (for payment creation)
export const USER_BANK_ACCOUNTS_QUERY = gql`
  query UserBankAccounts($organizationId: UUID) {
    userBankAccounts(organizationId: $organizationId) {
      id
      organizationId
      accountName
      accountType
      accountMask
      institutionName
      isPrimary
    }
  }
`;

// Check transaction exists query (deduplication)
export const CHECK_TRANSACTION_EXISTS_QUERY = gql`
  query CheckTransactionExists($externalTransactionId: String!) {
    checkTransactionExists(externalTransactionId: $externalTransactionId)
  }
`;
